import { API_PATHS } from '../constants/paths';
import type { OrdersApi } from '../types/api';
import type { HttpClient } from '../types/httpClient';
import { send } from '../utils/send';

/** The signed-in user's orders from the call center (`/cc/*`); the transport sends the token. */
export function createOrdersApi(http: HttpClient): OrdersApi {
    return {
        getList: () => send(http, 'resource', API_PATHS.CC_ORDER_LIST, { method: 'POST' }),

        reportProblem: (orderId: string, text: string) =>
            send(http, 'raw', API_PATHS.CC_ORDER_PROBLEM, { method: 'POST', body: { order_id: orderId, text } }),
    };
}
